'use client'

import { Route, Routes } from 'react-router-dom'

import { KybForm } from '@marketplace-web/pay-identity/pay-identity-kyc-feature'

import {
  AuthenticatedRoute,
  CompatibleRouter,
} from '@marketplace-web/vendor-abstractions/react-router-feature'
import { serverSide } from '@marketplace-web/environment/environment-util'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'

import ProNavBar from '../../components/ProNavBar'
import Register from '../../components/Register'
import { ROUTES, BUSINESS_ACCOUNTS_HOMEPAGE } from '../../constants/routes'
import WalletConversion from './WalletConversion'
import AddVatPage from './AddVatPage/AddVatPage'

const BusinessAccounts = () => {
  const { relativeUrl } = useBrowserNavigation()

  return (
    <CompatibleRouter basename={ROUTES.BASE} location={relativeUrl} isServerSide={serverSide}>
      <div className="u-flexbox u-flex-direction-column u-fill-viewport">
        <ProNavBar />
        <div className="u-flex-grow">
          <Routes>
            <Route
              path={`${ROUTES.REGISTER.BASE}/*`}
              element={
                <AuthenticatedRoute redirectRailsRoute={BUSINESS_ACCOUNTS_HOMEPAGE}>
                  <Register />
                </AuthenticatedRoute>
              }
            />
            <Route
              path={ROUTES.WALLET_CONVERSION}
              element={
                <AuthenticatedRoute redirectRailsRoute={BUSINESS_ACCOUNTS_HOMEPAGE}>
                  <WalletConversion />
                </AuthenticatedRoute>
              }
            />
            <Route
              path={ROUTES.KYB_FORM}
              element={
                <AuthenticatedRoute redirectRailsRoute={BUSINESS_ACCOUNTS_HOMEPAGE}>
                  <KybForm />
                </AuthenticatedRoute>
              }
            />
            <Route
              path={ROUTES.ADD_VAT}
              element={
                <AuthenticatedRoute redirectRailsRoute={BUSINESS_ACCOUNTS_HOMEPAGE}>
                  <AddVatPage />
                </AuthenticatedRoute>
              }
            />
          </Routes>
        </div>
      </div>
    </CompatibleRouter>
  )
}

export default BusinessAccounts
